import Typography from '@pedidosya/web-fenix/atoms/Typography';
import PropTypes from 'prop-types';
import { Row, TextSeparator } from '../styles/styles';
import { vendorItem as vendorItemTokens } from '../styles/vendorItem';

const textProps = vendorItemTokens.properties.fonts;

export const ConditionsInfoRow = ({ conditions }) => (
  <Row
    paddingTop="spacing-component-xsmall"
    paddingBottom="spacing-component-xsmall"
    color={textProps.conditions.textColor}
  >
    <Typography token={textProps.conditions.typography}>
      {conditions[0]}

      {conditions.length > 1 && (
        <>
          <TextSeparator>·</TextSeparator>
          {conditions[1]}
        </>
      )}
    </Typography>
  </Row>
);

ConditionsInfoRow.propTypes = {
  conditions: PropTypes.arrayOf(PropTypes.string).isRequired,
};
